import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SharedModule } from '../shared/shared.module';
import { AdminRoutingModule } from './admin-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { AppointmentDetailComponent } from './appointments/appointment-detail/appointment-detail.component';
import { ViewByDateComponent } from './calendar/view-by-date/view-by-date.component';
import { UsersComponent } from './users/users.component';
import { UserManageComponent } from './users/user-manage/user-manage.component';
import { UserDetailComponent } from './users/user-detail/user-detail.component';
import { DoctorsComponent } from './doctors/doctors.component';
import { DoctorManageComponent } from './doctors/doctor-manage/doctor-manage.component';
import { DoctorDetailComponent } from './doctors/doctor-detail/doctor-detail.component';
import { TherapistsComponent } from './therapists/therapists.component';
import { FacilitiesComponent } from './facilities/facilities.component';
import { FacilityManageComponent } from './facilities/facility-manage/facility-manage.component';
import { ImportExportComponent } from './import-export/import-export.component';
import { ReportsComponent } from './reports/reports.component';
import { ReportDetailComponent } from './reports/report-detail/report-detail.component';
import { SettingsComponent } from './settings/settings.component';
import { ApplicationComponent } from './settings/application/application.component';
import { PluginsComponent } from './settings/plugins/plugins.component';
import { NotificationsComponent } from './settings/notifications/notifications.component';
import { SearchResultsComponent } from '../admin/search-results/search-results.component';
import { UniquePipe } from 'src/app/pipes/unique.pipe';
import { CalendarModule, DateAdapter, MOMENT } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { SliderModule } from 'primeng/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CheckboxModule } from 'primeng/checkbox';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { DialogModule } from 'primeng/dialog';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { TooltipModule } from 'primeng/tooltip';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PanelMenuModule } from 'primeng/panelmenu';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CalendarModule as inlineCalendar } from 'primeng/calendar';
import { SalesOrderDetailComponent } from './appointments/sales-order-detail/sales-order-detail.component';
import { SalesorderCallLogsComponent } from './appointments/salesorder-call-logs/salesorder-call-logs.component';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DrawerModule } from 'primeng/drawer';
import { GeneralComponent } from './settings/general/general.component';
import { AppointmentComponent } from './settings/application/appointment/appointment.component';
import { SmsComponent } from './settings/plugins/sms/sms.component';
import { FtpComponent } from './settings/plugins/ftp/ftp.component';
import { VoiceCallComponent } from './settings/plugins/voice-call/voice-call.component';
import { VoiceMailComponent } from './settings/plugins/voice-mail/voice-mail.component';
import { CrmAppComponent } from './settings/plugins/crm-app/crm-app.component';
import { TherapistComponent } from './settings/notifications/therapist/therapist.component';
import { StaffComponent } from './settings/notifications/staff/staff.component';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';

import { AppoinmentCallListComponent } from './appointments/appoinment-call-list/appoinment-call-list.component';
import { AdminComponent } from './AdminComponent';
import { GlobalSearchService } from 'src/app/admin/servicies/globalSearch.service';
import { TwillioCallService } from 'src/app/admin/servicies/twillioCall.service';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MatTableModule } from '@angular/material/table';
import { BrightreeNewComponent } from './settings/brightree-new/brightree-new.component';
import { InputMaskModule } from 'primeng/inputmask';
import { MatSortModule } from '@angular/material/sort';
import { AppointmetsCancelledComponent } from './appointments/appointmets-cancelled/appointmets-cancelled.component';
import { PermissionsNewComponent } from './settings/application/permissions-new/permissions-new.component';

import { SyncRcmSalesorderComponent } from './import-export/sync-rcm-salesorder/sync-rcm-salesorder.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ManagePermissionsComponent } from './settings/application/permissions-new/manage-permissions/manage-permissions.component';
import { CancelVoidReasonsComponent } from './settings/brightree-new/cancel-void-reasons/cancel-void-reasons.component';
import { AddInsuranceDialogComponent } from './facilities/add-insurance-dialog/add-insurance-dialog.component';
import { TherapistManageNewComponent } from './therapists/therapist-manage-new/therapist-manage-new.component';
import { ReminderSettingComponent } from './settings/notifications/reminder-setting/reminder-setting.component';
import { HolidayComponent } from './settings/application/holiday/holiday.component';
import { HolidayManageComponent } from './settings/application/holiday/holiday-manage/holiday-manage.component';
import { BookAppointmentInfoComponent } from './book-appointment-info/book-appointment-info.component';
import { SidebarModule } from 'primeng/sidebar';
import { ConfirmAppointmentComponent } from './book-appointment-info/confirm-appointment/confirm-appointment.component';
import { AppointmentThankyouComponent } from './book-appointment-info/appointment-thankyou/appointment-thankyou.component';
import { SyncSalesorderByidComponent } from './import-export/sync-salesorder-byid/sync-salesorder-byid.component';
import { BranchComponent } from './settings/brightree-new/branch/branch.component';
import { SalesOrderHistoryComponent } from './appointments/sales-order-history/sales-order-history.component';
import { ReimportSalesorderByidComponent } from './import-export/reimport-salesorder-byid/reimport-salesorder-byid.component';
import { PipesModule } from '../pipes/pipes/pipes.module';
import { OnBoardingComponent } from './settings/on-boarding/on-boarding.component';
import { VoiceCallRecordingsComponent } from './voice-call-recordings/voice-call-recordings.component';
import { BulkUploadComponent } from './voice-call-recordings/bulk-upload/bulk-upload.component';
import { ExportReportComponent } from './reports/export-report/export-report.component';
import { AppointmentNoshowComponent } from './appointments/appointment-noshow/appointment-noshow.component';
import { AppointmentCancelOrderComponent } from './appointments/appointment-cancel-order/appointment-cancel-order.component';
import { TimeslotAvailabilitySummaryComponent } from './reports/timeslot-availability-summary/timeslot-availability-summary.component';
import { ViewAllNotificationsComponent } from './view-all-notifications/view-all-notifications.component';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { GoogleMapsModule } from '@angular/google-maps';
import { AppointmentUrgentCallbackComponent } from './appointments/appointment-urgent-callback/appointment-urgentcallback.component';
import { AutosyncSalesorderComponent } from './reports/autosync-salesorder/autosync-salesorder.component';
import { KpiReportComponent } from './reports/kpi-report/kpi-report.component';
import { TherapistAuditLogsComponent } from './therapists/therapist-audit-logs/therapist-audit-logs.component';
import { TodayDashboardComponent } from './dashboard/today-dashboard/today-dashboard.component';
import { TodaysDashboardListingComponent } from '../admin/todays-dashboard-listing/todays-dashboard-listing.component';
import { ViewTherapistAvailabilityV1Component } from './calendar/view-therapist-availability-v1/view-therapist-availability-v1.component';
import { WeekByTherapistSchedulerModuleV1 } from './calendar/week-by-therapist-scheduler-v1/week-by-therapist-scheduler-v1.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ViewMorePipe } from './therapists/view-more.pipe';
import { ClassificationTypeListComponent } from './settings/brightree-new/classification-type/classification-type-list/classification-type-list.component';
import { ClassificationTypeFormComponent } from './settings/brightree-new/classification-type/classification-type-form/classification-type-form.component';
import { SidebarService } from './servicies/sidebar.service';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { AdminMyChangePasswordComponent } from './users/my-change-password/admin-my-change-password.component';
import { AdminMyProfileComponent } from './users/my-profile/admin-my-profile.component';
import { SelfSchedulingConfigComponent } from './settings/application/self-scheduling-config/self-scheduling-config.component';
import { ValidationMessageDirective } from '../directive/validation-message.directive';
import { CreateConfigurationComponent } from './settings/application/self-scheduling-config/create-configuration/create-configuration.component';
import { PreviewConfigurationComponent } from './settings/application/self-scheduling-config/preview-configuration/preview-configuration.component';
import { PreviewTemplateComponent } from './settings/application/self-scheduling-config/preview-template/preview-template.component';
import { DynamicSidebarComponent } from './settings/dynamic-sidebar/dynamic-sidebar.component';
import { SelectModule } from 'primeng/select';

import { SchedulerModule } from 'angular-calendar-scheduler';
import * as moment from 'moment';
import { DatePickerModule } from 'primeng/datepicker';
import { TherapistDayViewSchedulerV1Component } from './calendar/therapist-day-view-scheduler-v1/therapist-day-view-scheduler-component-v1';
import { DayViewSchedulerV1Component } from './calendar/therapist-day-view-scheduler-v1/day-view-scheduler-v1.component';
import { MatSelectModule } from '@angular/material/select';
import { PaymentIntegrationComponent } from './settings/application/payment-integration/payment-integration.component';
import { PaymentsComponent } from './settings/plugins/payments/payments.component';

import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitButton } from 'primeng/splitbutton';
import { PaymentInformationComponent } from './appointments/payment-information/payment-information.component';
import { PaymentTransactionLogsComponent } from './reports/payment-transaction-logs/payment-transaction-logs.component';
import { InventoryMappingComponent } from './settings/brightree-new/inventory-mapping/inventory-mapping.component';
import { ReassignmentComponent } from './reassignment/reassignment.component';
@NgModule({
  declarations: [
    AdminComponent,
    DashboardComponent,
    AppointmentsComponent,
    AppointmentDetailComponent,
    ViewByDateComponent,
    UsersComponent,
    UserManageComponent,
    UserDetailComponent,
    DoctorsComponent,
    DoctorManageComponent,
    DoctorDetailComponent,
    TherapistsComponent,
    FacilitiesComponent,
    FacilityManageComponent,
    ImportExportComponent,
    AdminMyChangePasswordComponent,
    AdminMyProfileComponent,
    ReportsComponent,
    ReportDetailComponent,
    SettingsComponent,
    ApplicationComponent,
    PluginsComponent,
    NotificationsComponent,
    SearchResultsComponent,
    SalesOrderDetailComponent,
    SalesorderCallLogsComponent,
    GeneralComponent,
    AppointmentComponent,
    PaymentIntegrationComponent,
    SmsComponent,
    FtpComponent,
    PaymentsComponent,
    VoiceCallComponent,
    VoiceMailComponent,
    CrmAppComponent,
    TherapistComponent,
    StaffComponent,
    UniquePipe,
    AppoinmentCallListComponent,
    BrightreeNewComponent,
    AppointmetsCancelledComponent,
    PermissionsNewComponent,
    SyncRcmSalesorderComponent,
    ManagePermissionsComponent,
    ClassificationTypeListComponent,
    ClassificationTypeFormComponent,
    CancelVoidReasonsComponent,
    AddInsuranceDialogComponent,
    TherapistManageNewComponent,
    ReminderSettingComponent,
    HolidayComponent,
    HolidayManageComponent,
    BookAppointmentInfoComponent,
    ConfirmAppointmentComponent,
    AppointmentThankyouComponent,
    SyncSalesorderByidComponent,
    BranchComponent,
    InventoryMappingComponent,
    SalesOrderHistoryComponent,
    ReimportSalesorderByidComponent,
    OnBoardingComponent,
    VoiceCallRecordingsComponent,
    BulkUploadComponent,
    ExportReportComponent,
    AppointmentNoshowComponent,
    AppointmentCancelOrderComponent,
    TimeslotAvailabilitySummaryComponent,
    KpiReportComponent,
    ViewAllNotificationsComponent,
    AppointmentUrgentCallbackComponent,
    AutosyncSalesorderComponent,
    ViewTherapistAvailabilityV1Component,
    TherapistAuditLogsComponent,
    ViewMorePipe,
    TodayDashboardComponent,
    TodaysDashboardListingComponent,
    SelfSchedulingConfigComponent,
    PreviewTemplateComponent,
    PreviewConfigurationComponent,
    CreateConfigurationComponent,
    ValidationMessageDirective,
    DynamicSidebarComponent,
    DayViewSchedulerV1Component,
    TherapistDayViewSchedulerV1Component,
    PaymentInformationComponent,
    PaymentTransactionLogsComponent,
    ReassignmentComponent
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    InputTextModule,
    TabViewModule,
    TableModule,
    DropdownModule,
    SliderModule,
    SelectModule,
    MultiSelectModule,
    ScrollPanelModule,
    CheckboxModule,
    MenuModule,
    ButtonModule,
    OverlayPanelModule,
    DialogModule,
    DynamicDialogModule,
    TooltipModule,
    RadioButtonModule,
    CalendarModule,
    EditorModule,
    PanelMenuModule,
    InputSwitchModule,
    inlineCalendar,
    AccordionModule,
    AutoCompleteModule,
    FileUploadModule,
    SelectButtonModule,
    InputMaskModule,
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
    SchedulerModule.forRoot({ locale: 'en', headerDateFormat: 'daysRange' }),
    NgxDaterangepickerMd.forRoot({
      applyLabel: 'Okay',
      firstDay: 3
    }),
    MatTableModule,
    NgxMaterialTimepickerModule,
    SidebarModule,
    PipesModule,
    GoogleMapsModule,
    PopoverModule,
    DrawerModule,
    DragDropModule,
    WeekByTherapistSchedulerModuleV1,
    MatCheckboxModule,
    DatePickerModule,
    MatSelectModule,
    SplitButtonModule,
    SplitButton
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    TabViewModule,
    TableModule,
    DropdownModule,
    SliderModule,
    SelectModule,
    MultiSelectModule,
    ScrollPanelModule,
    CheckboxModule,
    MenuModule,
    ButtonModule,
    OverlayPanelModule,
    DialogModule,
    DynamicDialogModule,
    TooltipModule,
    RadioButtonModule,
    CalendarModule,
    PanelMenuModule,
    InputSwitchModule,
    inlineCalendar,
    AccordionModule,
    AutoCompleteModule,
    FileUploadModule,
    EditorModule,
    SelectButtonModule,
    PopoverModule,
    InputMaskModule,
    MatSortModule,
    SidebarModule,
    DragDropModule,
    ValidationMessageDirective,
    DatePickerModule,
    SplitButtonModule,
    SplitButton
  ],
  providers: [
    { provide: MOMENT, useValue: moment },
    UniquePipe,
    GlobalSearchService,
    TwillioCallService,
    DialogService,
    SidebarService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AdminModule {}
